export interface User {
  id: string;
  email: string;
  name: string;
  role?: 'player' | 'admin';
}

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly fields: Record<string, string> = {},
  ) {
    super(message);
  }
}

/** Appel JSON vers l'API. Le cookie de session (HttpOnly) est envoyé automatiquement par le navigateur. */
async function call<T>(method: 'GET' | 'POST', path: string, body?: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      method,
      credentials: 'same-origin',
      headers: body !== undefined ? { 'Content-Type': 'application/json' } : {},
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw new ApiError(0, 'network', 'Serveur injoignable. Vérifie ta connexion.');
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new ApiError(res.status, data.error ?? 'error', data.message ?? `Erreur ${res.status}`, data.fields);
  }
  return data as T;
}

export const api = {
  debugResetColony: () => call<{ok:boolean;backupId:string}>('POST','/api/debug/reset-colony',{confirm:true}),
  me: () => call<{ user: User | null }>('GET', '/api/auth/me'),
  signup: (b: { email: string; password: string; name: string }) => call<{ message: string }>('POST', '/api/auth/signup', b),
  verify: (token: string) => call<{ user: User }>('POST', '/api/auth/verify', { token }),
  resend: (email: string) => call<{ message: string }>('POST', '/api/auth/resend-verification', { email }),
  login: (b: { email: string; password: string }) => call<{ user: User }>('POST', '/api/auth/login', b),
  logout: () => call<{ ok: boolean }>('POST', '/api/auth/logout', {}),
  forgot: (email: string) => call<{ message: string }>('POST', '/api/auth/forgot', { email }),
  reset: (token: string, password: string) => call<{ user: User }>('POST', '/api/auth/reset', { token, password }),
};
